module.exports = "/images/sell-party-and-group-sales.svg?fa0168d4c43aae5c22b07f7a85eb53e0";